import * as React from 'react';

import { IAmpProps } from '../../typings/amp';

export interface IAmpImgProps
  extends IAmpProps,
    React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> {
  src?: string;
  alt?: string;
}

const AmpImg: React.FC<IAmpImgProps> = ({ src = '', alt = '', width = '100', height = '100', layout = 'fixed' }) => {
  return <amp-img src={src} alt={alt} layout={layout} width={width} height={height} />;
};

export default AmpImg;
